"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WalletFactory = void 0;
var ethers_1 = require("ethers");
var WalletFactory = /** @class */ (function () {
    function WalletFactory() {
    }
    /**
     * Checks a wallet from mnemonic phrase
     *
     * @param {string} mnemonic - the mnemonic phrase
     * @param {string} [hdPath] - hdPath
     * @returns {EthersWallet} - returns signer/wallet obj
     */
    WalletFactory.prototype.createWalletFromMnemonic = function (mnemonic, hdPath) {
        // TODO: verify mnemonic and hdpath
        return ethers_1.Wallet.fromMnemonic(mnemonic, hdPath);
    };
    /**
     * Checks a wallet from private key
     *
     * @param {string} privateKey - the private key
     * @returns {Wallet} - returns signer/wallet obj
     */
    WalletFactory.prototype.createWalletFromPrivateKey = function (privateKey) {
        return new ethers_1.Wallet(privateKey);
    };
    /**
     * Creates a new wallet
     *
     * @returns {Wallet} - returns signer/wallet obj
     */
    WalletFactory.prototype.createNewWallet = function () {
        return ethers_1.Wallet.createRandom();
    };
    /**
     * Checks if is a valid mnemonic
     *
     * @param {string} mnemonic - the mnemonic phrase
     * @returns {boolean} - returns if is a valid mnemonic
     */
    WalletFactory.prototype.isMnemonicValid = function (mnemonic) {
        return ethers_1.utils.isValidMnemonic(mnemonic);
    };
    /**
     * Create the HD path to be used when creating keys
     *
     * @param {number} [index=0] - index of the wallet
     * @example
     * getHDPath(1) -> returns m/44'/330'/0'/0/0
     * @returns {string} - returns the path
     */
    WalletFactory.prototype.getHDPath = function (index) {
        if (index === void 0) { index = 0; }
        var COIN_TYPE = 60;
        var ACCOUNT = 0;
        var CHAIN = 0;
        return "m/44'/".concat(COIN_TYPE, "'/").concat(ACCOUNT, "'/").concat(CHAIN, "/").concat(index);
    };
    return WalletFactory;
}());
exports.WalletFactory = WalletFactory;
